export const lightTheme = {
  "--color-primary": "#bbad94",
  "--color-primary-darker": "#ac9a7d",
  "--color-primary-lighter": "#f2efe9",
  "--color-text-primary": "#353546",
  "--color-text-secondary": "#848491",
  "--color-background-primary": "white",
  "--color-background-secondary": "#f2efe9",
};

export const darkTheme = {
  "--color-primary": "#474854",
  "--color-primary-darker": "#ac9a7d",
  "--color-primary-lighter": "#726b60",
  "--color-text-primary": "#f2efe9",
  "--color-text-secondary": "#808080",
  "--color-background-primary": "#34353e",
  "--color-background-secondary": "#25262c",
};
